import React, { useEffect, useState } from 'react'
import SubTitle from '../Components/SubTitle'
import Order_section from '../Components/Order_section'
import ProductShow from '../Components/ProductShow'
import Loading from './Loading'
import axios from 'axios'
import { URL } from '../config'

const AllProducts = () => {
  const titles=[{name:'جميع المنتجات',link:''}]
  const [products,setProducts]=useState([]);
  const [nextPage,setNextPage]=useState('');
  const [path,setPath]=useState('');
  const [load,setLoad]=useState(false);
  useEffect(()=>{
    setLoad(true);
    axios.get(`${URL}/api/product/all_product`)
    .then(function (response) {
      if(response.data.success){
        console.log('response.data.data',response.data.data);
        setProducts(response.data.data.data);
        setNextPage(response.data.data.next_page_url);
        setPath(response.data.data.path);
      }
      setLoad(false);
        })
    .catch(function (error) {
      console.log('error');
      setLoad(false);
    });
  },[])
  if(load)
    return <Loading/>
  return (
    <div className='container-fluid mt-lg-5 pt-5 mb-2'>
        <SubTitle titles={titles}/>
        <ProductShow products={products} nextPage={nextPage} nextPath={path} titles={titles}/>
    </div>
  )
}

export default AllProducts
